import Text from "@amzn/meridian/text";
import { useLocation } from "react-router-dom";
import { useAppSelector } from "src/store/store";
import Chat from "./components/chat/chat";
import saigeLogo from "src/images/saige_logo.svg";
import "./home.scss";

const HomePage = () => {
  const location = useLocation();
  const { firstName } = useAppSelector((state) => state.user);
  const { showResult } = useAppSelector((state) => state.chatSlice);
  const isOnMcpRoute = location.pathname === "/mcp";

  return (
    <div className="home">
      <div className="home__main-container">
        {!showResult &&
          (isOnMcpRoute ? (
            <div className="home__greet">
              <Text className="home__greeting">
                <span>Hello, {firstName}</span>
              </Text>
              <Text className="home__greeting-info">
                How can I help you today?
              </Text>
            </div>
          ) : (
            <div className="saige-header">
              <img src={saigeLogo} alt="SAIGE Logo" className="saige-logo" />
              <Text type="h600" alignment="left">
                SAIGE - North America
              </Text>
              <Text className="saige-subtitle" alignment="left">
                AI Assistant for Safety Procedures
              </Text>
              <Text type="b400" alignment="left">
                SAIGE provides general information and is not a substitute for
                Amazon's official workplace health and safety procedures. This
                tool does not offer legal advice. For the most accurate and
                up-to-date information, always refer to the official procedures.
                Direct any legal questions to your Legal POC.
              </Text>
            </div>
          ))}
        <Chat isOnMcpRoute={isOnMcpRoute} />
      </div>
    </div>
  );
};

export default HomePage;
